export enum MaintenanceType {
  DATA = 'data',
  ROUTINE = 'routine',
  OFFLINE = 'offline'
}
